/* eslint-disable eol-last */
import React, { useEffect } from "react";
import { Row, Col, Button, Form, Input, Select, message } from "antd";
import pluse from "../../../../assests/images/childpackagePluseIcon.svg";
import crosImgForChildBagagge from "../../../../assests/images/onbording/delete-box.svg";
// import { useLocation } from "react-router";
import axios from "axios";
import { APIs } from "../../../../utils/worker";
function EditDeliveryDetails({
  form,
  setFormValues,
  formValues,
  apiResponse,
  //   visible,
  itemkey,
}) {
  const { Option } = Select;
  let arr = apiResponse?.premiseDto?.deliveryPincodes;
  // useEffect(() => {
  //   if (itemkey === 3) {
  //     // form.setFieldValue("CPPin", apiResponse?.premiseDto?.pincode);
  //     // let temp = [];
  //     // for (let i = 0; i < arr.length; i++) {
  //     //   temp.push({
  //     //     id: Math.random().toString(36).slice(2),
  //     //     pinCode: "",
  //     //     areaName: [],
  //     //     disabledAreaName: [],
  //     //   });
  //     // }
  //     // setFormValues(temp);
  //     // for (let j = 0; j < temp.length; j++) {
  //     //   form.setFieldValue("CPPin" + temp[j].id, arr[j].deliveryPin);
  //     //   form.setFieldValue(
  //     //     "service" + temp[j].id,
  //     //     arr[j].pincodeServiceabilityType
  //     //   );
  //     //   form.setFieldValue("Areaname" + temp[j].id, arr[j].serviceableAreas);
  //     // }
  //     // form.setFieldValue("CPPin" + 0, apiResponse?.premiseDetails?.pincode);
  //     // form.setFieldValue("CPPin" + 0, apiResponse?.premiseDetails?.pincode);

  //     // let arr = [{}, {}];
  //     // arr.map((item, index) => {
  //     //   temp.push({
  //     //     id: Math.random().toString(36).slice(2),
  //     //     pinCode: "",
  //     //     areaName: [],
  //     //     disabledAreaName: [],
  //     //   });
  //     // });

  //     // setFormValues([
  //     //   // ...formValues,
  //     //   { id: randomString, pinCode: "", areaName: [], disabledAreaName: [] },
  //     // ]);

  //     // handleChangeSearch(apiResponse?.premiseDetails?.pincode?.toString(), 0);
  //   }
  // }, [itemkey]);

  let addFormFields = () => {
    let randomString = Math.random().toString(36).slice(2);
    setFormValues([
      ...formValues,
      { id: randomString, pinCode: "", areaName: [], disabledAreaName: [] },
    ]);
  };

  let removeFormFields = (id) => {
    form.setFieldValue("Areaname" + id, null);
    form.setFieldValue("CPPin" + id, null);
    let newFormValues = [...formValues];
    newFormValues.splice(
      newFormValues.findIndex(function (i) {
        return i.id === id;
      }),
      1
    );
    // newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const handleChangeSearch = async (e, idx) => {
    // let formData = form.getFieldValue();
    if (e?.length == 6) {
      let userData = JSON.parse(localStorage.getItem("userinfo"));
      axios
        .get(`${APIs.baseURL}/pincode-service/v1/pincode/${e}`, {
          headers: {
            Authorization: "Bearer " + userData.accessToken,
          },
        })
        .then((response) => {
          if (
            response.data.enable == true &&
            response.data.serviceability.serviceability !== "Non-Serviceable"
          ) {
            let tempArray = [];
            response?.data?.areadto?.map((area) =>
              tempArray.push({ label: area.areaName, value: area.areaId })
            );
            let apiData = response?.data?.areadto?.map((area) => area.areaId);
            form.setFieldValue(`Areaname${idx}`, apiData);
            let newFormValues = [...formValues];
            Object.keys(newFormValues).forEach((el) => {
              if (newFormValues[el].id === idx) {
                newFormValues[el]["areaName"] = tempArray;
                newFormValues[el]["pinCode"] = e;
              }
            });
            setFormValues(newFormValues);
          } else {
            message.error(`${e} this pincode is disabled`);
          }
        })
        .catch((error) => {
          message.error(error?.response?.data?.message);
        });
    } else {
      form.setFieldValue(`Areaname${idx}`, []);
      form.setFieldValue(`nonServiceableArea${idx}`, []);
    }
  };

  const onClickOption = (e, v, id) => {
    let gotValues = formValues;
    let index = gotValues.findIndex((item) => item.id === id);
    gotValues[index] = {
      ...gotValues[index],
      disabledAreaName: [...gotValues[index].disabledAreaName, v.children],
    };
    setFormValues([...gotValues]);
    let nonServiceArea = form.getFieldValue("nonServiceableArea" + id);
    form.setFieldValue("nonServiceableArea" + id, [
      ...nonServiceArea,
      v.children,
    ]);
  };
  const onClickNonservice = (e, v, id) => {
    let gotValues = formValues;
    let index = gotValues.findIndex((item) => item.id === id);
    let areaNames = gotValues[index].areaName;
    let actualValue = areaNames.find((item) => item.label === v.value).value;
    let newvalues = gotValues[index].disabledAreaName.filter(
      (item) => item !== v.children
    );
    gotValues[index] = {
      ...gotValues[index],
      areaName: [...gotValues[index].areaName, actualValue],
      disabledAreaName: [...newvalues],
    };
    setFormValues([...gotValues]);
    let seriveceArea = form.getFieldValue("Areaname" + id);
    form.setFieldValue("Areaname" + id, [...seriveceArea, actualValue]);
  };
  const onChangeHandler = (e, v, id) => {
    let gotValues = formValues;
    let index = formValues.findIndex((x) => x.id === id);
    let newareas = gotValues[index].disabledAreaName.filter(
      (xy) => xy !== v[v.length - 1].children
    );
    if (gotValues[index].disabledAreaName.includes(v[v.length - 1].children)) {
      gotValues[index] = {
        ...gotValues[index],
        disabledAreaName: [...newareas],
      };
      setFormValues([...gotValues]);
      form.setFieldValue("nonServiceableArea" + id, [...newareas]);
    }
  };
  return (
    <div>
      <Row gutter={40} className="global-form-row booking-details-container">
        <Col lg={7} className="form-inputs" style={{ marginTop: "0" }}>
          <Form.Item
            name="CPPin"
            label={"CP PIN code"}
            rules={[
              {
                required: true,
                message: "Please enter pincode",
              },
            ]}
          >
            <Input
              placeholder="Enter CP pincode"
              type="text"
              maxLength={20}
              disabled={true}
              // onChange={(e) => handleChangeSearch(e)}
            />
          </Form.Item>
        </Col>
      </Row>
      {formValues.map((element, index) => (
        <div key={index} className="border-box">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              padding: "10px",
            }}
          >
            <div>
              <Button
                type="text"
                style={{
                  background: "none",
                  paddingRight: "20px",
                  paddingTop: "10px",

                  visibility: index === 0 ? "hidden" : "show",
                }}
              >
                <img
                  src={crosImgForChildBagagge}
                  className="delete-child-input-button"
                  onClick={() => {
                    removeFormFields(element.id);
                  }}
                />
              </Button>
            </div>
          </div>
          <Row
            gutter={40}
            className="global-form-row booking-details-container "
          >
            <Col lg={6} xs={24} style={{ marginTop: "0" }}>
              <Form.Item
                name={"CPPin" + element.id}
                label={"Delivery PIN code"}
                rules={[
                  {
                    required: true,
                    message: "Please Delivery Pincode",
                  },
                ]}
              >
                <Input
                  placeholder="Enter CP pincode"
                  type="text"
                  maxLength={6}
                  // onChange={(e) =>
                  //   handleChangeSearch(e.target.value, element.id)
                  // }
                />
              </Form.Item>
            </Col>
            <Col lg={6} xs={24}>
              <Form.Item name={"service" + element.id} label="Service">
                <Select
                  placeholder="Select Service"
                  options={[
                    {
                      value: "Regular",
                      label: "Regular",
                    },
                    {
                      value: "Regular & E-commerce",
                      label: "Regular & E-commerce",
                    },
                    {
                      value: "ODA1",
                      label: "ODA1",
                    },
                    {
                      value: "ODA2",
                      label: "ODA2",
                    },
                  ]}
                ></Select>
              </Form.Item>
            </Col>
            <Col lg={9} xs={24}>
              <Form.Item
                style={{ marginTop: "0" }}
                label="Serviceable area"
                className="serviceable-area"
                name={"Areaname" + element.id}
                rules={[
                  {
                    required: true,
                    message: "Please select an option",
                  },
                ]}
              >
                <Input placeholder="Enter CP" type="text" />
              </Form.Item>
            </Col>
          </Row>
        </div>
      ))}
      <div className="delevery-pincode">
        <div className="child-baggage-modal-inputList-button">
          <Button
            style={{
              background: "none",
              border: " 1px solid #2E77D0",
              color: "#2E77D0",
              width: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "5px",
            }}
            type="dashed"
            onClick={() => addFormFields()}
          >
            <img src={pluse} style={{ margin: "5px" }} /> ADD DELIVERY PINCODE
          </Button>
        </div>
      </div>
    </div>
  );
}
export default EditDeliveryDetails;
